import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import styles from './ItemControlModal.module.scss'

function ItemControlModal({ show, setShow, containerRef }) {
   // const [show, setShow] = useState(false);

   return (



      <Modal
         show={show}
         onHide={() => setShow(false)}
         // dialogClassName="modal-90w"
         container={containerRef?.current}
         backdrop={false}
         dialogClassName={styles.modalWrapper}
         aria-labelledby="example-custom-modal-styling-title"


         enforceFocus={false}
         autoFocus={false}
         restoreFocus={false}
      >
         <Modal.Header closeButton>
            <Modal.Title id="example-custom-modal-styling-title">
               Custom Modal Styling
            </Modal.Title>
         </Modal.Header>
         <Modal.Body>
            <div className={styles.body_content}></div>
         </Modal.Body>
      </Modal>

   );
}

export default ItemControlModal;